<template>
	<div class="ks-details" v-loading="loadingAll">
		<div>
			<div class="flex flex-just-between">
				<div class="left">
					<div class="flex">
						<div class="border-right yx-color-text-primary flex flex-align-center fz-14 pr-12" v-if="isExclusive">
							<div :class="['state_icon', stateClass]"></div>
							<div class="ml-4">{{ row['activity_status_desc'] }}</div>
						</div>
						<p class="font-bold">{{ row.activity_name }}</p>
					</div>
					<div class="flex-column mt-12 fz-14">
						<p class="pb-12">
							<span class="color-gy-7 pr-12">创建时间</span>
							<span class="yx-color-text-primary">{{ row.create_time }}</span>
						</p>
						<p class="pb-12">
							<span class="color-gy-7 pr-12">活动时间</span>
							<span class="yx-color-text-primary">{{ row.apply_start_time + ' 至 ' + row.apply_end_time }}</span>
						</p>
						<p v-if="isExclusive">
							<span class="color-gy-7 pr-12">支持类型</span>
							<span class="yx-color-text-primary">{{ row.preExclusiveActivitySignTypeDesc }}</span>
						</p>
					</div>
				</div>
				<div class="right flex">
					<el-button v-if="isExclusive" type="primary" @click="addTalent(0)">添加达人</el-button>
					<el-button
						v-if="$auth.hasPermi('system:myActivities:copyLink') && ['2', '3'].includes(row.activity_status)"
						type="primary"
						@click="copyActivityId(row.activity_url)"
					>
						商家报名链接
					</el-button>
					<el-button
						v-if="$auth.hasPermi('system:myActivities:copyLink') && activityLinkAuth"
						type="primary"
						@click="copyActivityId(row.activity_url_institution)"
					>
						团长报名链接
					</el-button>
					<el-button v-if="isShowClose && $auth.hasPermi('system:myActivities:close')" @click="activityFun(1)">关闭活动</el-button>
					<el-button v-if="isShowDel && $auth.hasPermi('system:myActivities:delete')" @click="activityFun(0)">删除活动</el-button>
				</div>
			</div>
			<div :class="['flex mt-20', tableKeyArr.length > 1 ? 'flex-just-between' : '']">
				<tableBox
					:class="['table-box', 'flex-1']"
					v-for="(item, index) in tableKeyArr"
					:tableList="row[item.key]"
					:key="index"
					:type="item.key"
					:columns="item.column"
					:authorityId="authorityId"
					:thirdActivityId="third_activity_id"
					@refresh="refreshDetails"
				></tableBox>
			</div>
		</div>
		<div class="list mt-30">
			<div class="flex flex-align-center flex-just-between">
				<p class="font-bold">报名商品</p>
			</div>
			<search @onSubmit="onSubmit" :PLATFORM_KS="PLATFORM_KS"></search>
			<div class="tab">
				<div class="btn flex flex-align-center flex-just-between">
					<div class="flex flex-align-center">
						<div class="ml-14 mr-18 font-h5-regular">
							<!-- <el-checkbox @change="checkeFun" v-model="allChecked">当页全选</el-checkbox> -->
							已选
							<span class="color-p-4">{{ selectionShopArr.length || 0 }}</span>
						</div>
						<template v-if="(isShopPartnerDataView || isAllDataView) && $auth.hasPermi('system:myActivities:commodityAudit')">
							<el-tooltip placement="top" :disabled="!!selectionShopArr.length" content="至少选择一条数据">
								<el-button @click="batchFun('2')" type="primary">通过</el-button>
							</el-tooltip>
							<el-tooltip placement="top" :disabled="!!selectionShopArr.length" content="至少选择一条数据">
								<el-button @click="batchFun('3')" type="primary">拒绝</el-button>
							</el-tooltip>
							<el-button class="mr-8" v-if="$auth.hasPermi('system:myActivities:export')" @click="exportFun" :loading="exportLoading">导出</el-button>
							<updateTime :type="sync_type" ref="updateTime" @updateList="updateList"></updateTime>
						</template>
					</div>
				</div>
				<multi-table
					v-loading="loading"
					element-loading-text="加载中"
					element-loading-background="rgba(255, 255, 255)"
					ref="multiTable"
					:columns="columns"
					@gePartnerList="gePartnerList"
					:list="list"
					:options="options"
					:total="total"
					:selectionChange="selectionChange"
				>
					<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
				</multi-table>
			</div>
		</div>
		<confirmDialog ref="confirmDialog" @refresh="refreshDetails"></confirmDialog>

		<!-- 添加达人 -->
		<addTalentDialog ref="addTalentDialog" @refresh="refreshDetails" />
		<AuditPass ref="auditPass" @refreshList="refreshList" />
		<AuditReject ref="auditReject" @refreshList="refreshList" />
	</div>
</template>
<script>
import tableBox from './components/tableBox.vue';
import updateTime from '../../components/updateTime.vue';
import search from './components/ksSearch.vue';
import { columns } from './ksColumns';
import { activitySync, ksProductList, ksActivityAudit, activityDetail, ksActivityExport } from '@/api/secondColonelManage';
import empty from '@/views/common/empty/index.vue';
import { PLATFORM_KS, activityType, ksUpActivityType, ksAuditStatusType } from '@/utils/dataMap';
import { copy } from '@/utils/common';
import confirmDialog from './components/confirmDialog.vue';
import { mapGetters } from 'vuex';
import addTalentDialog from './components/addTalentDialog.vue';
import AuditPass from './components/auditPass.vue';
import AuditReject from './components/auditReject.vue';
import { getAuditConfig } from '@/api/settings.js';
export default {
	components: {
		tableBox,
		updateTime,
		search,
		empty,
		confirmDialog,
		addTalentDialog,
		AuditPass,
		AuditReject,
	},
	data() {
		return {
			sync_type: activityType.myActivityGoods,
			params: {
				page_index: 1,
				page_size: 10,
			},
			loading: false,
			loadingAll: false,
			columns,
			list: [],
			options: { selectable: true },
			total: '0',
			isSearch: false,
			allChecked: false,
			selectionShopArr: [],
			PLATFORM_KS: PLATFORM_KS.value,
			ksUpActivityType,
			ksAuditStatusType,
			row: {},
			exportLoading: false,
			productAuditClaim: 0,
		};
	},
	computed: {
		...mapGetters(['isAllDataView', 'isShopPartnerDataView', 'isDrPartnerDataView']),
		activity_id() {
			return this.$route.query.id;
		},
		third_activity_id() {
			return this.$route.query.third_activity_id;
		},
		//是否专属
		isExclusive({ row }) {
			return row.activity_type === '2';
		},
		//是否是合作招商
		isCooperatione({ row }) {
			return +row.activity_type === 3;
		},
		activityLinkAuth({ row }) {
			if (
				['2', '3'].includes(row.activity_status) &&
				(+row.activity_type === 1 || (+row.activity_type === 2 && !['0', '1'].includes(row.preExclusiveActivitySignType)))
			) {
				return true;
			} else {
				return false;
			}
		},
		tableKeyArr({ isExclusive }) {
			const activity_anchor = {
				key: 'activity_anchor',
				column: [
					{ label: '达人昵称', prop: 'outer_anchor_name' },
					{ label: '达人账号', prop: 'outer_anchor_id' },
				],
			};
			const activity_category = {
				key: 'activity_category',
				column: [
					{ label: '商品类目', prop: 'category_names' },
					{ label: '佣金最低要求', prop: 'min_commission_rate', template: true },
				],
			};
			const activity_institution = {
				key: 'activity_institution',
				column: [
					{ label: '团长名称', prop: 'institution_name' },
					{ label: '机构ID', prop: 'authority_id' },
				],
			};
			let arr = [activity_category];
			if (this.row.preExclusiveActivitySignType == 3) {
				//支持类型为指定团长可见
				arr.push(activity_institution);
			}
			if (isExclusive) {
				arr.push(activity_anchor);
			}

			return arr;
		},
		isShowClose({ row }) {
			return row['activity_status'] === ksUpActivityType.Published || row['activity_status'] === ksUpActivityType.promotion;
		},
		isShowDel({ row }) {
			return row['activity_status'] === ksUpActivityType.end;
		},
		stateClass({ row }) {
			let calss = '';
			switch (row['activity_status']) {
				case ksUpActivityType.Unpublished:
					calss = 'warning';
					break;
				case ksUpActivityType.Published:
					calss = 'success';
					break;
				case ksUpActivityType.promotion:
					calss = 'success';
					break;
				case ksUpActivityType.end:
					calss = 'danger';
					break;
			}
			return calss;
		},
		authorityId() {
			return this.$route.query.authority_id;
		},
	},
	created() {
		this.activityDetail();
		this.activityList();
		this.getAuditConfigInfo();
	},
	mounted() {
		const { PLATFORM_KS, third_activity_id } = this;
		this.$refs.updateTime.getSyncTime(third_activity_id, PLATFORM_KS);
	},
	methods: {
		async activityDetail() {
			this.loadingAll = true;
			const { activity_id, PLATFORM_KS: platform_id } = this;
			const { code, data } = await activityDetail({ activity_id, platform_id });
			if (code !== 0) return;
			this.row = data;
			this.loadingAll = false;
		},
		async activityList(value, isSearch = false) {
			const { activity_id, authorityId: authority_id } = this;
			this.loading = true;
			this.isSearch = isSearch;
			const { code, data } = await ksProductList({ activity_id, ...this.params, authority_id });
			if (code !== 0) return;
			this.list = data.list.map(item => {
				return {
					...item,
					operations: this.getButtons(item),
				};
			});
			this.total = data.page.item_total + '';
			this.loading = false;
		},
		//操作按钮
		getButtons(item) {
			let arr = [];
			const { isShopPartnerDataView, isAllDataView, authorityId: authority_id } = this;
			arr.push(
				{
					label: '通过',
					type: 'text',
					classtype: 2,
					notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
					disabled: item.forbidden_user_follow,
					disabledTooltip: item.forbidden_user_follow,
					tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
					isShow:
						item.audit_status === ksAuditStatusType.toBeReviewed &&
						(isShopPartnerDataView || isAllDataView) &&
						this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						let content = '确认审核商品，通过后将分配给指定的招商运营，未选择则不进行分配';
						if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && this.productAuditClaim) {
							content = '确认审核商品，通过后将自动认领商品';
						}
						if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && !this.productAuditClaim) {
							content = '确认审核商品？';
						}
						this.$refs.auditPass.show(
							[
								{
									third_product_ids: row.third_product_id,
									third_activity_id: this.third_activity_id,
									product_id: row.product_id,
								},
							],
							content,
						);
					},
				},
				{
					label: '拒绝',
					type: 'text',
					classtype: 2,
					notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
					disabled: item.forbidden_user_follow,
					disabledTooltip: item.forbidden_user_follow,
					tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
					isShow:
						item.audit_status === ksAuditStatusType.toBeReviewed &&
						(isShopPartnerDataView || isAllDataView) &&
						this.$auth.hasPermi('system:myActivities:commodityAudit'),
					click: row => {
						this.$confirm(`确认拒绝商品？`, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
						})
							.then(() => {
								this.ksActivityAudit(row.third_product_id, ksAuditStatusType.rejected, authority_id, row.product_id);
							})
							.catch(() => {});
					},
				},
			);
			return arr.filter(item => item.isShow);
		},
		async ksActivityAudit(third_product_ids, audit_status, authority_id, product_id) {
			const { third_activity_id } = this;
			let is_claim = 0;
			const { code } = await ksActivityAudit({
				third_activity_id,
				third_product_ids,
				audit_status,
				is_claim,
				authority_id,
				product_id,
			});
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.refreshList();
		},
		batchFun(value) {
			if (!this.selectionShopArr.length) return;
			if (this.selectionShopArr.length > 100) {
				return this.$message.error('批量审核的商品数不可超过100个');
			}
			let rows = this.selectionShopArr.filter(item => item.audit_status === ksAuditStatusType.toBeReviewed);
			if (rows.length === 0) {
				this.$message.warning("仅处理'待审核'状态的商品");
				return;
			}
			rows = rows.filter(item => !item.forbidden_user_follow);
			if (rows.length === 0) {
				this.$message.warning('未选择可审核商品');
				return;
			}
			let content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>通过后将分配给指定的招商运营，未选择则不进行分配`;
			if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && this.productAuditClaim) {
				content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>通过后将自动认领商品`;
			}
			if (!this.$auth.hasPermi('system:myActivities:distributeGoods') && !this.productAuditClaim) {
				content = `<span>已选</span><span style="color: #2475FF" class="mr-4 ml-4">${rows.length}</span><span>个待审核商品，</span>确认审核商品？`;
			}
			if (value == 2) {
				this.$refs.auditPass.show(rows, content, true);
			} else {
				this.$refs.auditReject.show(rows, `已选${rows.length}个待审核商品，拒绝后将不可恢复，确认要操作吗？`);
			}
		},
		async updateList() {
			const { third_activity_id, sync_type, PLATFORM_KS: platform_id } = this;
			const { code } = await activitySync({
				item_id: third_activity_id,
				type: sync_type,
				platform_id,
				authority_id: this.authorityId,
			});
			if (code !== 0) return;
			this.$message({
				iconClass: 'el-icon-info primary mr-10',
				message: '商品正在同步...',
			});
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.refreshList();
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs.multiTable.resetPage();
			this.refreshList(true);
		},
		refreshList(isSearch) {
			const { activity_id } = this;
			this.activityList(activity_id, isSearch);
		},
		refreshDetails(type) {
			if (type) {
				this.activityDetail();
				this.activityList();
			} else {
				this.$router.push({
					path: '/secondColonelManage/myActivities/list',
				});
			}
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			const selectLength = this.selectionShopArr.length;
			this.allChecked = selectLength && selectLength === this.list.length;
		},
		//选中值
		checkeFun(e) {
			this.$refs.multiTable.toggleSelection(this.list, e);
		},
		copyActivityId(val) {
			copy(val);
			this.$message.success('复制成功');
		},
		async exportFun() {
			try {
				this.exportLoading = true;
				const { activity_id, PLATFORM_KS: platform_id, authorityId: authority_id } = this;
				const { download_url } = await ksActivityExport({ activity_id, ...this.params, platform_id, authority_id });
				this.exportLoading = false;
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
				this.exportLoading = false;
			}
		},
		activityFun(type) {
			const { activity_id, authorityId } = this;
			let title = type ? '确认关闭活动' : '确认删除活动？';
			let content = type ? '该活动在报名中，若关闭会导致报名商品状态失效，也会影响团长信誉度，请确认是否关闭!' : '是否删除该活动，删除后无法恢复!';
			this.$refs.confirmDialog.show(title, activity_id, content, type, authorityId);
		},
		addTalent() {
			this.$refs.addTalentDialog.show(this.third_activity_id, this.authorityId);
		},
		// 获取商品审核设置
		async getAuditConfigInfo() {
			const { data, code } = await getAuditConfig({ platformId: this.PLATFORM_DY });
			if (code === 0) {
				this.productAuditClaim = data.productAuditClaim;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.table-box {
	// width: 40%;
	min-width: 30%;
	& + & {
		margin-left: 30px;
	}
	/deep/ .el-table__body-wrapper {
		max-height: 168px;
		height: auto;
		overflow-y: auto;

		&::-webkit-scrollbar {
			width: 6px;
		}

		&::-webkit-scrollbar-thumb {
			height: 26px;
			border-radius: 3px;
			background-color: @border-color-lighter;
		}
	}
}
.ks-details {
	.state_icon {
		width: 8px;
		height: 8px;
		border-radius: 50%;
	}

	.warning {
		background-color: @color-warning;
	}

	.success {
		background-color: @color-success;
	}

	.danger {
		background-color: @color-danger;
	}

	.list {
		.tab {
			.btn {
				padding: 24px 0px 16px 0px;
				border-top: 1px solid #eeeeee;
			}
		}
	}
}
</style>
